/**
 * Created by HeMengJiao on 2020/03/16.
 * edit bu zxf on 2021/07/10
 */
import officeAutomation from './modules/officeAutomation'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
  modules:{
    officeAutomation
  },
  state: {
    user: {},
    token: null,
    company_id: '',
    title: '将来网',
    company: '',
    path: '',

  },
  mutations: {
    updateToken(state, newToken) {
      state.token = newToken
    },
    updateUserInfo(state, newUserInfo) {
      state.user = newUserInfo
    },
    updateCompany(state, company) {
      state.company = company
    },
    updateCompanyId(state, curCompanyId) {
      state.company_id = curCompanyId
    },
    updatePath(state, curpath) {
      state.path = curpath
    },
    updateTitle(state, newTitle) {
      state.title = newTitle
    },
    loginOut(state, data) {
      state.token = null
      state.user = {}
    },

  },
  actions: {
    //token
    updateToken({commit},payload){
      commit('updateToken',payload)
    },
    //userInfo
    updateUserInfo({commit},payload){
      commit('updateUserInfo',payload)
    },

  }
})




// WEBPACK FOOTER //
// ./src/store/store.js